export const getMrFundReportApi = (queryParam, query) => {
    const queryString = new URLSearchParams(query).toString();
    return queryParam?.event ? `/invoices/${queryParam?.lease_slug}/mr-reports?as_of_date=${queryParam?.as_of_date}&event_id=${queryParam?.event}&asset_id=${queryParam?.asset_id}&asset_type=${queryParam?.asset_type}&${queryString ? `${queryString}` : ""}` : `/invoices/${queryParam?.lease_slug}/mr-reports?as_of_date=${queryParam?.as_of_date}&asset_id=${queryParam?.asset_id}&asset_type=${queryParam?.asset_type}&${queryString ? `${queryString}` : ""}`;
};
export const getMrFundBalanceApi = (queryParam,query) => {
        const queryString = new URLSearchParams(query).toString();
    return `/invoices/${queryParam?.lease_slug}/mr-reports-cards?as_of_date=${queryParam?.as_of_date}&${queryString ? `${queryString}` : ""}`;

}
export const getMajorAssemblyApi = (params) => {
    return `console/${params?.leaseSlug}/major-assembly`;
}
export const getMaintenanceEventApi = (params,assetType,assetId) => {
    return `maintenance-events/?lease_slug=${params?.leaseSlug}&asset_id=${assetId}&asset_type=${assetType}`;
}
export const getConsantApi = () => {
    return `lease/constants/get_by_constant_types`;
}
export const getMrCurrencyApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `invoices/currency${queryString ? `?${queryString}` : ""}`;
}
